var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"first-login","fluid":""}},[_c('FirstLoginForm',{attrs:{"width":"500px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }